import {Button, Modal} from "react-bootstrap";
import React from "react";
import Select from "react-select";
import ModalMsg from "../../../components/ModalMsg";
import Translate from "../../../components/Translate";

export default function ModalAddAssociatiView({
                                                  show,
                                                  handleClose,
                                                  translate,
                                                  showMsg,
                                                  setShowMsg,
                                                  modalMsg,
                                                  onChangeUtente,
                                                  getOptionsUtenti,
                                                  onClickConferma,
                                                  getValueUtenti,
                                          }) {

    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header
                className={'ns-modal-header'}
                closeVariant='white'
                closeButton>
                <Modal.Title>{translate('Aggiungi utenti')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalMsg
                    show={showMsg}
                    handleClose={() => setShowMsg(false)}
                    testo={modalMsg}/>
                <div className={"row"}>
                    <div className={"col-md-12"}>
                        <Select
                            id="id_utente"
                            name="id_utente"
                            onChange={onChangeUtente}
                            value={getValueUtenti}
                            options={getOptionsUtenti}
                            placeholder={translate("Seleziona utenti")}
                            isMulti
                        />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <Translate>Annulla</Translate>
                </Button>
                <Button variant="primary" onClick={onClickConferma}>
                    <Translate>Conferma</Translate>
                </Button>
            </Modal.Footer>
        </Modal>
    )

}